import { render, staticRenderFns } from "./productFreight.vue?vue&type=template&id=26e600b3&scoped=true"
import script from "./productFreight.vue?vue&type=script&lang=js"
export * from "./productFreight.vue?vue&type=script&lang=js"
import style0 from "./productFreight.vue?vue&type=style&index=0&id=26e600b3&prod&lang=stylus&scoped=true"
import style1 from "./productFreight.vue?vue&type=style&index=1&id=26e600b3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e600b3",
  null
  
)

export default component.exports